import { SITE_PAGES } from 'Config';
import { user_org_roles, user_roles } from 'Data/Enum';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router';
import { isUserAuthorized } from 'Util';
import AdminLanding from '../AdminLanding';
import OrganizationDetails from './OrganizationDetails';

const OrganizationDetailsPage = ({ params }) => {
  let breadcrumbs = params?.id && [
    SITE_PAGES.MANAGE_FACILITIES,
    {
      icon: 'office',
      text: params.id,
    },
  ];

  return (
    <AdminLanding title='Manage Core Facility' breadcrumbs={breadcrumbs}>
      {isUserAuthorized({
        roles: [
          user_roles.ADMINISTRATOR,
          [params?.id, user_org_roles.MANAGER.key],
        ],
      }) ? (
        <OrganizationDetails editable params={params} />
      ) : (
        <Navigate to={SITE_PAGES.ACCESS_DENIED.to} />
      )}
    </AdminLanding>
  );
};

OrganizationDetailsPage.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string }),
};

export default OrganizationDetailsPage;
